import { Equipment } from '__generated__/graphql';
import classNames from 'classnames';
import CertificationDetails, { CertificationDetailsType } from 'components/foundation/CertificationDetails/CertificationDetails';
import { ICertificationLinkFormData } from 'components/foundation/CertificationDetails/CertificationLinkForm/CertificationLinkForm';
import { ClassName } from 'types/ClassName';
import IEquipment from 'types/Equipment';
import { isoTimeStampUtc } from 'utils/dateUtils';
import './EquipmentCertificationsDetails.scss';
import { useCertificationEquipmentLinks } from './useCertificationEquipmentLinks';
import { useMutateCertificationEquipmentLinks } from './useMutateCertificationEquipmentLinks';

export interface IEquipmentCertificationsDetailsProps {
  className?: ClassName;
  equipment: IEquipment | Equipment;
}

const EquipmentCertificationsDetails = (props: IEquipmentCertificationsDetailsProps) => {
  const { className, equipment } = props;

  const { data, isLoading, refetch } = useCertificationEquipmentLinks({
    equipmentId: equipment.id,
  });

  const { createCertificationEquipmentLink, updateCertificationEquipmentLink } = useMutateCertificationEquipmentLinks();

  function handleDelete(id: string) {
    updateCertificationEquipmentLink({ id, deletedOn: isoTimeStampUtc() }).then(() => {
      refetch();
    });
  }

  function handleSubmit(data: ICertificationLinkFormData) {
    if (data.certificationId) {
      createCertificationEquipmentLink({
        certificationId: data.certificationId,
        equipmentId: equipment.id,
        createdOn: isoTimeStampUtc(),
      }).then(() => {
        refetch();
      })
    }
  }

  const classes = classNames('equipment-certifications-details mt-6', className);

  return (
    <div className={classes}>
      <CertificationDetails
        type={CertificationDetailsType.EQUIPMENT}
        data={data ?? []}
        loading={isLoading}
        objectTitle={equipment.equipmentName}
        onDelete={handleDelete}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default EquipmentCertificationsDetails;
